import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '',
    meta: {
      auth: true
    },
    component: () => import('./../components/Layout'),
    children: [
      {
        path: '/',
        name: 'dashboard',
        component: () => import(/* webpackChunkName: "about" */ '../views/DashboardView.vue')
      },
      {
        path: '/scanner',
        name: 'scanner',
        component: () => import(/* webpackChunkName: "about" */ '../views/QrCodeScannerView.vue')
      },
      {
        path: '/guests',
        name: 'guests',
        component: () => import(/* webpackChunkName: "about" */ '../views/GuestListView.vue')
      },
        {
            path: '/sms',
            name: 'sms',
            component: () => import(/* webpackChunkName: "about" */ '../views/SmsView.vue')
        },
      {
        path: '/users',
        name: 'users',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/UsersView.vue')
      },
    ]
  },
  {
    path: '/login',
    name: 'login',
    meta: {
      title: 'menu.login',
      auth: false
    },
    component: () => import('./../views/LoginView')
  },
  {
    path: '/reservation',
    name: 'reservation',
    meta: {
      title: 'menu.reservation'
    },
    component: () => import('./../views/HomeQRView')
  },
  {
    path: '/404',
    component: () => import('../views/Error/Error404'),
    name: 'not_found',
    meta: {
      title: 'menu.404'
    },
  },
  {
    path: '/403',
    component: () => import('../views/Error/Error403'),
    name: 'forbidden',
    meta: {
      title: 'menu.403'
    }
  },
  {
    path: '*',
    redirect: { name: 'not_found' }
  },
]

const router = new VueRouter({
  mode: process.env.NODE_ENV === 'production' ? 'history' :'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
